import { Manager } from '@/types/park/manager'

export const manager1: Manager = {
    id: 1,
    name: 'Freego',
    email: 'freego@manager.com',
    category: {
        id: 1,
        name: 'Industrie',
        priority: 1,
    },
    phone: '0134233556',
}
